import {Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {Subscription} from "rxjs";
import {MatTableDataSource} from "@angular/material/table";
import { toggleLoading } from "../../../redux";
import { SubscriptionService} from "../../services";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {ToastrService} from "ngx-toastr";
import {MatDialog} from "@angular/material/dialog";
import {LockInModalComponent} from "../lock-in-modal/lock-in-modal.component";
import {
  ConfirmationModalComponent,
  DeleteConfirmationModalComponent,
} from "../../../shared/components";
import {NotesModalComponent} from "../notes-modal/notes-modal.component";
import {UtilService} from "../../../shared/services";
import {ModalSize} from "../../../shared/services/util/util.service";
import {IDealSubscription} from "../../models";
import { UuidService, LookupService } from 'src/app/services';
import { DataService } from 'src/app/services/data/data.service';
import { SubdocService } from '../../services/subdoc/subdoc.service';
import { IDealSubscriptionItem } from '../../models/subscription';
import { ISyndicationItem, ISyndicationSubdoc, ISubDocFieldsResponse } from '../../models/syndication';
import { DealSubscriptionSubdocEditModalComponent } from '../deal-subscription-subdoc-edit-modal/deal-subscription-subdoc-edit-modal.component';
import { DealSubscriptionSubdocFormModalComponent } from '../deal-subscription-subdoc-form-modal/deal-subscription-subdoc-form-modal.component';
import { DealSubscriptionSubdocModalComponent } from '../deal-subscription-subdoc-modal/deal-subscription-subdoc-modal.component';
import { IndicateInterestModalComponent } from '../indicate-interest-modal/indicate-interest-modal.component';
import { SubscriptionModalComponent } from '../subscription-modal/subscription-modal.component';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
}) 
export class SubscriptionComponent {

  syndication!: IDealSubscription;
  dataSource: MatTableDataSource<IDealSubscriptionItem> = new MatTableDataSource();
  matchesColsToDisplay = ['businessUnit', 'amount', 'notes', 'status', 'date', 'actions', 'subdocs'];
  subdocCols = ['amount', 'status', 'created', 'actions'];
  subDocsOnlyTableColumns = ['investor', 'amount', 'status', 'date', 'actions'];
  showSubDocsTableOnly: boolean = false;
  subDocsDataSource: MatTableDataSource<ISyndicationSubdoc> = new MatTableDataSource();

  highlightId : string = '';


  constructor(
    private subscriptionService: SubscriptionService,
    private subDocService: SubdocService,
    private store: Store,
    private toastrService: ToastrService,
    public dialog: MatDialog,
    public util: UtilService,
    private uuid: UuidService,
    private activatedRoute: ActivatedRoute,
    public lookupService: LookupService,
    private dataService: DataService,
    private renderer: Renderer2, private elRef: ElementRef
    
  ) {
    this.getSyndication();
  }

  getSyndication() {
    console.log("Fetching Subscription...");
    this.store.dispatch(toggleLoading({loading: true}));
    this.subscriptionService.getSubscription().subscribe({
      next: (subscription: IDealSubscription) => {
        console.log("Got subscription dto", subscription);
        subscription.subscriptionItems.map(x => x.expanded = false)
        this.syndication = subscription;
        // this.store.dispatch(updateDealSubscription({dealSubscription: subscription}));
        this.dataSource.data = this.syndication.subscriptionItems;
        // highlight any syndication or subdoc rows via query param
        var syndicationId = this.activatedRoute.snapshot.queryParamMap.get("syndicationId");
        var subDocId = this.activatedRoute.snapshot.queryParamMap.get("subDocId");

        var subdocs : ISyndicationSubdoc[] = subscription.subscriptionItems.flatMap(x => x.subDocs);
        subdocs.sort((a, b) => {
          let dateA = new Date(a.created);
          let dateB = new Date(b.created);
          return dateB.getTime() - dateA.getTime();
        });
        this.subDocsDataSource.data = subdocs;
        // this.subDocsDataSource.data = subscription.subscriptionItems.flatMap(x => x.subDocs);

        if (!!syndicationId) {
          setTimeout(() => {
            const row = this.elRef.nativeElement.querySelector(`#syndication-${syndicationId}`);
            if (row) {
              this.renderer.setStyle(row, 'background-color', '#ffeac3');
            }
          }, 500)
        }

        if (!!subDocId) {
          // open the syndication row & highlight the subdoc Id
          this.showSubDocsTableOnly = true;
          setTimeout(() => {
            const row = this.elRef.nativeElement.querySelector(`#subdoc-${subDocId}`);
            if (row) {
              this.renderer.setStyle(row, 'background-color', '#ffeac3');
            }
          }, 500)
        }
        // this.dataSource = new MatTableDataSource(this.subscription.subscriptionItems);
        this.store.dispatch(toggleLoading({loading: false}));
      }, error: err => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastrService.error("Unable to get subscription!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  editAllocationModal(element: ISyndicationItem) {
    this.dialog.open(SubscriptionModalComponent, {
      height: 'auto',
      width: 'auto',
      data: element
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        this.store.dispatch(toggleLoading({loading: true}));
        this.subscriptionService.updateSubscription(element).subscribe({
          next: (res: any) => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.success("Subscription Updated!", $localize`:@@companyName:Rondeivu`);
          }, error: err => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.error("Unable to update subscription!", $localize`:@@companyName:Rondeivu`);
          }
        });
      }
    });
  }

  changeLockStatus(locked: boolean) {
    this.dialog.open(LockInModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.SMALL),
      maxWidth: '800px',
      data: { locked },
      disableClose: true
    })
    .afterClosed().subscribe(result => {
      console.log("Dialog output:", result);
      if (result === true) {

        let payload = {
          isLocked: locked,
          silentPoolLockChange: true // this is for backwards compatability
        };
    
        this.store.dispatch(toggleLoading({loading: true}));
        this.subscriptionService.changeLockStatus(payload).subscribe({
          next: (res: any) => {
            // this.matchesSource = new MatTableDataSource(this.syndication.syndicationItems);
            this.syndication.issuerPoolIsLocked = locked;
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.success(locked ? "Pool Locked!" : "Pool Unlocked!", $localize`:@@companyName:Rondeivu`);
          }, error: err => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.error("Unable to change lock status!", $localize`:@@companyName:Rondeivu`);
          }
        });

      }
    });

  }

  // save(element: any) {
  //   this.store.dispatch(toggleLoading({loading: true}));
  //   this.subscriptionService.updateSubscription(element).subscribe({
  //     next: (res: any) => {
  //       this.store.dispatch(toggleLoading({loading: false}));
  //       this.toastrService.success("Subscription Updated!", $localize`:@@companyName:Rondeivu`);
  //     }, error: err => {
  //       this.store.dispatch(toggleLoading({loading: false}));
  //       this.toastrService.error("Unable to update subscription!", $localize`:@@companyName:Rondeivu`);
  //     }
  //   });
  // }

  delete(element: any) {
   this.dialog.open(DeleteConfirmationModalComponent, {
      height: 'auto',
      width: 'auto',
      data: element
    })
    .afterClosed().subscribe(result => {
      // console.log("Dialog output:", result);
      if (!!result) {
        this.store.dispatch(toggleLoading({loading: true}));
        this.subscriptionService.deleteSubscription(result).subscribe({
          next: (res: any) => {
            //replace in list
            if (!!result) {
              let idx = -1;
              for (let i = 0; i <= this.syndication.subscriptionItems?.length - 1; i++) {
                if (this.syndication.subscriptionItems[i].id == result.id) {
                  idx = i;
                  break;
                }
              }
              this.syndication.subscriptionItems.splice(idx, 1);
              this.dataSource = new MatTableDataSource(this.syndication.subscriptionItems);
            }
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.success("Subscription Removed!", $localize`:@@companyName:Rondeivu`);
          }, error: err => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.error("Something went wrong!");
          }
        });
      }
    });
  }

  showNotes(notes: string) {
    this.dialog.open(NotesModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {notes: notes}
    });
  }


  subscribe() {
      this.dialog.open(SubscriptionModalComponent, {
        height: 'auto',
        width: this.util.getModalWidth(ModalSize.MEDIUM),
        maxWidth: '800px',
        data: {},
        disableClose: true
      })
      .afterClosed().subscribe((result: any) => {
        console.log("Initiate Subscription Dialog output:", result);
        if (!!result) {
          this.store.dispatch(toggleLoading({loading: true}));
          this.subscriptionService.subscribe(result).subscribe({
            next: (res: any) => {
              this.toastrService.success("Interest Indicated!", $localize`:@@companyName:Rondeivu`);
              this.store.dispatch(toggleLoading({loading: false}));
              this.getSyndication();
            }, error: err => {
              this.store.dispatch(toggleLoading({loading: false}));
              this.toastrService.error("Unable to indicate interest!", $localize`:@@companyName:Rondeivu`);
            }
          });
        }
      });
  }
  
  /**
   * Opens the sub doc modal
   * @param element
   */
  openSubdocModal(element: ISyndicationItem) {
    const delRef = this.dialog.open(DealSubscriptionSubdocModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {
        businessUnitId: element.investor.id,
        subscriptionId: element.id,
        amount: element.indicationAmount
      },
      disableClose: true
    });

    delRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.getSyndication();
      }
    });
  }

  /**
   * Edit the sub doc
   * @param element
   */
  editSubdoc(element: ISyndicationSubdoc) {
    console.log("Edit subdoc", element);
    // get the data and inject it into the
    this.store.dispatch(toggleLoading({loading: true}));
      this.subDocService.getDocumentFields(element.id).subscribe({
        next: (fields: ISubDocFieldsResponse) => {
          this.store.dispatch(toggleLoading({loading: false}));

          this.dialog.open(DealSubscriptionSubdocEditModalComponent, {
            height: 'auto',
            width: 'auto',
            data: {
              subdoc: element
            },
            disableClose: true
          }).
          afterClosed().subscribe(result => {
            if (!!result) {
              this.getSyndication();
            }
          });

        }, error: err => {
          this.store.dispatch(toggleLoading({loading: false}));
          this.toastrService.error("Unable to get fields!", $localize`:@@companyName:Rondeivu`);
        }
      });
   
  }

  downloadSubdoc(element: ISyndicationSubdoc) {
    this.store.dispatch(toggleLoading({loading: true, message: "This operation may take a few seconds!"}));
    this.subDocService.getSubdocPdf(element.id).subscribe({
      next: (res: Blob) => {
        let dt = element.subscriptionDate.split('T')[0];
        let filename = element.entityName + '-' + dt + '.pdf';
        let blob: Blob = res as Blob;
        let a = document.createElement('a');
        a.download = filename;
        a.href = window.URL.createObjectURL(blob);
        a.click();
        this.store.dispatch(toggleLoading({loading: false}));
      },
      error: (err: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastrService.error("Unable to download file!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }


  /**
   * Delete the sub doc
   * @param element
   */
  deleteSubdoc(element: ISyndicationSubdoc) {
    this.dialog.open(DeleteConfirmationModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {
        subdoc: element
      }
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        let id = result.subdoc.id;
        this.store.dispatch(toggleLoading({loading: true}));
        this.subDocService.deleteSubdoc(id).subscribe({
          next: (res: any) => {
            this.getSyndication();
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.success("Sub Doc Removed!", $localize`:@@companyName:Rondeivu`);
          }, error: err => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.error("Unable to remove sub doc!", $localize`:@@companyName:Rondeivu`);
          }
        });
      }
    });
  }

  
  fillSubdoc(element: ISyndicationSubdoc, isRondeivu: boolean) {
    // get the data and inject it into the
    this.store.dispatch(toggleLoading({loading: true, message: "This may take a few seconds!" }));
      this.subDocService.getDocumentFields(element.id).subscribe({
        next: (fields: ISubDocFieldsResponse) => {
          this.store.dispatch(toggleLoading({loading: false}));

          this.dialog.open(DealSubscriptionSubdocFormModalComponent, {
            height: 'auto',
            width: 'auto',
            minWidth: '900px',
            data: {
              fields: fields
            },
            disableClose: true
          }).
          afterClosed().subscribe(result => {
            if (!!result) {
              this.getSyndication();
            }
          });

        }, error: err => {
          this.store.dispatch(toggleLoading({loading: false}));
          this.toastrService.error("Unable to get fields!", $localize`:@@companyName:Rondeivu`);
        }
      });
  }


  // /**
  //  * Approve the investor sub doc
  //  * @param element
  //  */
  // approveInvestorSubdoc(element: ISyndicationSubdoc) {
  //   this.dialog.open(ConfirmationModalComponent, {
  //     height: 'auto',
  //     width: 'auto',
  //     data: {
  //       subdoc: element
  //     }
  //   })
  //   .afterClosed().subscribe(result => {
  //     if (!!result) {
  //       let id = result.subdoc.id;
  //       this.store.dispatch(toggleLoading({loading: true}));
  //       this.subDocService.approvalSendToInvestor(id, {}).subscribe({
  //         next: (res: any) => {
  //           this.getSyndication();
  //           this.store.dispatch(toggleLoading({loading: false}));
  //           this.toastrService.success("Sub Doc Approved!", $localize`:@@companyName:Rondeivu`);
  //         }, error: err => {
  //           this.store.dispatch(toggleLoading({loading: false}));
  //           this.toastrService.error("Unable to approve sub doc!", $localize`:@@companyName:Rondeivu`);
  //         }
  //       });
  //     }
  //   });
  // }

  /**
   * Approve Issuer the sub doc
   * @param element
   */
  // approveIssuerSubdoc(element: ISyndicationSubdoc) {
  //   const confirm = this.dialog.open(ConfirmationModalComponent, {
  //     height: 'auto',
  //     width: 'auto',
  //     data: {
  //       subdoc: element
  //     }
  //   });

  //   confirm.afterClosed().subscribe(result => {
  //     if (!!result) {
  //       let id = result.subdoc.id;
  //       this.store.dispatch(toggleLoading({loading: true}));
  //       this.subDocService.approvalSendToIssuer(id, {}).subscribe({
  //         next: (res: any) => {
  //           this.getSyndication();
  //           this.store.dispatch(toggleLoading({loading: false}));
  //           this.toastrService.success("Sub Doc Issuer Approved!", $localize`:@@companyName:Rondeivu`);
  //         }, error: err => {
  //           this.store.dispatch(toggleLoading({loading: false}));
  //           this.toastrService.error("Unable to issuer approve sub doc!", $localize`:@@companyName:Rondeivu`);
  //         }
  //       });
  //     }
  //   });
  // }

}

